import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryList from "@/pages/category/page";
import ComicDetail from "@/pages/detail/page";
import SearchPage from "@/pages/search/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/category/:type", element: <CategoryList /> },
  { path: "/detail/:id", element: <ComicDetail /> },
  { path: "/search", element: <SearchPage /> },
  { path: "/about", element: <About /> },
  { path: "*", element: <NotFound /> },
];

export default routes;